export const filterNewsType = (news, type) => news.filter((item) => item.newType === type)

export const filterDisplayTips = (news, type, displayLocation) => {
  const filterTips = filterNewsType(news, type)
  return filterTips.filter((item) => item.displayLocation === displayLocation)
}
